import Grid from '@mui/material/Grid2';
import { emptyGridStyles, StyledEmptyTypography } from './styles';

type EmptyRowProps = {
  message: string;
  endAddon?: React.ReactNode;
};

export const EmptyRow = ({ message, endAddon, ...props }: EmptyRowProps) => {
  return (
    <Grid container {...props}>
      <Grid sx={emptyGridStyles}>
        <StyledEmptyTypography>{message}</StyledEmptyTypography>
        {endAddon}
      </Grid>
    </Grid>
  );
};
